import { Box, Typography } from '@mui/material';
import { Cancel } from '@mui/icons-material';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const GridErrorBoundaryFallback = ({ error }: { error: any }) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  const errorParsed = new Error(error).message;

  return (
    <Box sx={t => ({
      width: '100%',
      flexDirection: 'column',
      gap: 1,
      display: 'flex',
      p: 1,
      borderRadius: '12px',
      border: `1px solid ${t.palette.error.main}`,
    })}>
      <Box sx={{
        flexDirection: 'row',
        display: 'flex',
        gap: 1 / 2,
        alignItems: 'center',
      }}>
        <Cancel color={'error'} />
        <Typography variant={'body2'} color={'error'}>An unexpected error happened.</Typography>
      </Box>
      {error && errorParsed && (
        <Box sx={{
          display: 'block',
          width: '100%',
          minHeight: 28,
          position: 'relative',
        }}>
          <Typography variant={'caption'} sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            display: 'block',
            width: '100%',
            position: 'absolute',
          }}>{errorParsed}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default GridErrorBoundaryFallback;